/**
 * Chave de escrita do documento pelo dono (USU-076, P-PAR-FINAL).
 *
 * O OnPoint tem "Gerenciar documentos" no grupo Permissoes - Tomador. No servidor,
 * quando o dono do documento e o tomador, exigir, editar, enviar, excluir e restaurar
 * conferem `documentos.tomador.update` no lugar das chaves do repositorio. A tela
 * segue a mesma troca, para nao mostrar botao que o servidor recusa.
 */
export const CHAVE_DOCUMENTOS_DO_TOMADOR = 'documentos.tomador.update';

type ChaveDoRepositorio =
  | 'documentos.documento.create'
  | 'documentos.documento.update'
  | 'documentos.documento.delete';

export function chaveDeEscrita(ownerType: string, geral: ChaveDoRepositorio): string {
  return ownerType === 'tomador' ? CHAVE_DOCUMENTOS_DO_TOMADOR : geral;
}
